import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import req from "../req";
import config from "../config";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import Icon from "../sections/MUI/Icon";
import {toast} from "react-toastify";

class Facilities extends Component {

    state = {
        facilities: null,

        title: "",
        price: "",
        registerPrice: "",
        link: "",
        formTitle: "",
        form: [],

        modalAdd: false,
        editIndex: -1
    };

    componentDidMount() {
        this.getFacilities();
    }


    getFacilities() {
        req.get(`/facilities`)
            .then(r => {
                r = r ? r : [];
                this.setState({facilities: r});
            });
    }

    addFormField() {
        let {form, formTitle} = this.state;
        formTitle = formTitle.toString().trim();

        if (formTitle !== "") {
            form.push(formTitle);
            this.setState({
                form,
                formTitle: ""
            });
        }
    }

    handleFormFieldChange(index, value) {
        let {form} = this.state;
        form[index] = value;
        this.setState({form});
    }

    handleFormFieldDelete(index = 0) {
        let {form} = this.state;
        form.splice(index, 1);
        this.setState({form});
    }

    submit() {
        let {title, price, registerPrice, form, link} = this.state;
        title = config.getStringValue(title, "");
        price = config.getStringValue(price, "").replace(/,/g, "");
        registerPrice = config.getStringValue(registerPrice, "").replace(/,/g, "");
        form = form ? form : [];
        toast.info("در حال ثبت ...");
        req.post(`/facilities`, {
            title,
            price,
            registerPrice,
            form,
            link
        })
            .then(r => {
                toast.success("با موفقیت ثبت شد.");
                this.setState({
                    title: "",
                    price: "",
                    registerPrice: "",
                    formTitle: "",
                    form: [],
                    link: ""
                });
                this.getFacilities();
            });
    }

    edit() {
        let {facilities, editIndex} = this.state;
        let {_id, title, price, registerPrice, form, link} = facilities[editIndex];
        title = config.getStringValue(title, "");
        price = config.getStringValue(price, "").replace(/,/g, "");
        registerPrice = config.getStringValue(registerPrice, "").replace(/,/g, "");
        form = form ? form : [];
        toast.info("در حال ویرایش ...");
        req.put(`/facilities`, {
            id: _id,
            title,
            price,
            registerPrice,
            form,
            link
        })
            .then(r => {
                toast.success("با موفقیت ویرایش شد.");
                this.setState({
                    formTitle: "",
                    editIndex: -1
                });
                this.getFacilities();
            });
    }

    delete(id = "") {
        toast.info("در حال حذف ...");
        req.delete(`/facilities?id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.getFacilities();
            });
    }

    render() {
        let {
            facilities,
            title,
            price,
            registerPrice,
            formTitle,
            form,
            link,
            modalAdd, editIndex
        } = this.state;
        return (
            <div className="facilities">
                {this.editModal()}
                <Modal display={modalAdd}
                       onCloseClick={() => this.setState({modalAdd: false})}
                       title="ثبت طرح تسهیلات">
                    <div className="modal-add-facilities">
                        <Field name="title"
                               value={title}
                               label="نام طرح"
                               maxLength={355}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                        <Field name="price"
                               value={price}
                               typePrice
                               label="مبلغ تسهیلات (تومان)"
                               maxLength={20}
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                        <Field name="registerPrice"
                               value={registerPrice}
                               typePrice
                               label="هزینه ثبت نام (تومان)"
                               maxLength={20}
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                        <Field name="link"
                               value={link}
                               label="لینک ثبت نام طرح"
                               maxLength={1000}
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.setState({[name]: value})}/>

                        <div className="form">
                            <div className="row">
                                <div className="col">
                                    <Field name="formTitle"
                                           value={formTitle}
                                           label="عنوان فیلد"
                                           onChange={(name, value) => this.setState({[name]: value})}
                                           maxLength={255}/>
                                </div>
                                <div className="col-auto">
                                    <Icon i="plus" solid className="add-form-title-icon"
                                          onClick={() => this.addFormField()}/>
                                </div>
                            </div>
                            {form.map((f, i) =>
                                <div className="field" key={"field" + i}>
                                    <div className="row">
                                        <div className="col">
                                            <Field name={"formTitle-" + i}
                                                   value={f}
                                                   label="عنوان فیلد"
                                                   onChange={(name, value) => this.handleFormFieldChange(i, value)}
                                                   maxLength={255}/>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="minus" solid className="remove-form-title-icon"
                                                  onClick={() => this.handleFormFieldDelete(i)}/>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    <Button icon="check" onClick={() => this.submit()}>ذخیره طرح</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Back {...this.props}/>
                <br/>

                <div className="row">
                    <div className="col-5">
                        <Button icon="plus" onClick={() => this.setState({modalAdd: true})}>ثبت طرح</Button>
                    </div>
                </div>
                <br/>

                <div className="list">
                    {facilities ?
                        facilities.length > 0 ?
                            facilities.map((f, i) =>
                                <article key={"f" + i}>
                                    <div className="row">
                                        <div className="col">
                                            <p className="title">
                                                <span>{f.title}</span><span>({config.priceFormatter(f.price)})</span>
                                            </p>
                                            <p className="register-price">
                                                <span>هزینه ثبت نام:</span><span>{config.priceFormatter(f.registerPrice)}</span>
                                            </p>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="edit"
                                                  className="edit-icon"
                                                  onClick={() => this.setState({editIndex: i})}/>
                                            <Icon i="trash"
                                                  className="delete-icon"
                                                  onDoubleClick={() => this.delete(f._id)}/>

                                        </div>
                                    </div>
                                </article>
                            )
                            : <p style={{textAlign: "center"}}>موردی نیست!</p>

                        : <p style={{textAlign: "center"}}>در حال دریافت ...</p>}
                </div>
            </div>
        );
    }

    handleInputEditChange(name, value) {
        let {facilities, editIndex} = this.state;
        facilities[editIndex][name] = value;
        this.setState({
            facilities
        });
    }

    addFormFieldEdit() {
        let {editIndex, facilities, formTitle} = this.state;
        let {form} = facilities[editIndex];
        formTitle = formTitle.toString().trim();

        if (formTitle !== "") {
            form.push(formTitle);
            this.setState({
                facilities,
                formTitle: ""
            });
        }
    }

    handleFormFieldEditChange(index, value) {
        let {facilities, editIndex} = this.state;
        facilities[editIndex]["form"][index] = value;
        this.setState({
            facilities
        });
    }

    handleFormFieldEditDelete(index = 0) {
        let {facilities, editIndex} = this.state;
        let form = facilities[editIndex].form;
        form.splice(index, 1);
        this.setState({form});
    }

    editModal() {
        let {editIndex, facilities, formTitle} = this.state;

        if (editIndex === -1) {
            return null;
        }

        let {_id, title, price, registerPrice, form, link} = facilities[editIndex];

        return (
            <Modal display={editIndex !== -1}
                   title="ویرایش طرح"
                   onCloseClick={() => this.setState({editIndex: -1})}>

                <div className="modal-add-facilities">
                    <Field name="title"
                           value={title}
                           label="نام طرح"
                           maxLength={355}
                           onChange={(name, value) => this.handleInputEditChange(name, value)}/>
                    <Field name="price"
                           value={price}
                           typePrice
                           label="مبلغ تسهیلات (تومان)"
                           maxLength={20}
                           style={{direction: "ltr"}}
                           onChange={(name, value) => this.handleInputEditChange(name, value)}/>
                    <Field name="registerPrice"
                           value={registerPrice}
                           typePrice
                           label="هزینه ثبت نام (تومان)"
                           maxLength={20}
                           style={{direction: "ltr"}}
                           onChange={(name, value) => this.handleInputEditChange(name, value)}/>
                    <Field name="link"
                           value={link}
                           label="لینک ثبت نام طرح"
                           maxLength={1000}
                           style={{direction: "ltr"}}
                           onChange={(name, value) => this.handleInputEditChange(name, value)}/>
                    <div className="form">
                        <div className="row">
                            <div className="col">
                                <Field name="formTitle"
                                       value={formTitle}
                                       label="عنوان فیلد"
                                       onChange={(name, value) => this.setState({[name]: value})}
                                       maxLength={255}/>
                            </div>
                            <div className="col-auto">
                                <Icon i="plus" solid className="add-form-title-icon"
                                      onClick={() => this.addFormFieldEdit()}/>
                            </div>
                        </div>
                        {form.map((f, i) =>
                            <div className="field" key={"field" + i}>
                                <div className="row">
                                    <div className="col">
                                        <Field name={"formTitle-" + i}
                                               value={f}
                                               label="عنوان فیلد"
                                               onChange={(name, value) => this.handleFormFieldEditChange(i, value)}
                                               maxLength={255}/>
                                    </div>
                                    <div className="col-auto">
                                        <Icon i="minus" solid className="remove-form-title-icon"
                                              onClick={() => this.handleFormFieldEditDelete(i)}/>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <Button icon="check" onClick={() => this.edit()}>ویرایش کردن</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default gpn(Facilities);